import { datetimeFormatter, formatCoordinates, formatMeasuredValue } from '../../../shared/utils';
import '../DashboardTableInfractions.module.css'
import { IInfractionResult } from '../models/InfractionResult';
import style from '../DashboardTableInfractions.module.css'
import { ATTENTIVEDRIVINGKEYTRANSLATOR } from '../hooks/useAttentiveDrivingKeyTranslator';
import { ATTENTIVEDRIVINGVALUETRANSLATOR } from '../hooks/useAttentiveDrivingValueTranslator';

type ExpandedRowDetailsProps = {
  row: any;
  colSpan: number;
  tableClassNames: string;
  infractionName: string;
  handleShowMap: (lat: number, lng: number) => void;
};

const MISSING_VALUE = '---';

const ExpandedRowDetails = ({ row, colSpan, tableClassNames, infractionName, handleShowMap }: ExpandedRowDetailsProps) => {
  const subColumnsTitles = ['Data/Hora', 'Localização', 'Valor Medido'];
  const subColumnsTitlesAttentiveDriving = ['Data/Hora', 'Localização', 'Causa'];
  const totalCols = colSpan;
  const emptyHeadersCount = totalCols - subColumnsTitles.length;
  const emptyCellsCount = totalCols - subColumnsTitles.length;

  const countsDetails = row.items.map((item: any) => item.detailCauses?.length || 0);
  const headerDiscount = Math.max(...countsDetails);

  const GROUP_COLORS = [
    { bg: '#fff5f0', color: '#ff8e3c', border: '#ff8e3c' },
    { bg: '#f6ffed', color: '#3690ae', border: '#3690ae' },
    { bg: '#e6f7ff', color: '#626b72', border: '#626b72' },
    { bg: '#fff7e6', color: '#94488b', border: '#94488b' },
  ];

  return (
    <tr>
      <td colSpan={colSpan} style={{ padding: 0, margin: 0 }}>
        <table width='100%' className={tableClassNames}>
          <thead>
            <tr className='extendedRow'>
              {infractionName == "IT_ATTENTIVE_DRIVING" ? (
                subColumnsTitlesAttentiveDriving.map((col, index) => (
                  <th key={col} className={`text-left ${style.extendedRowSpace}`}>
                    <span>{col}</span>
                  </th>
                ))
              ) : (
                subColumnsTitles.map(col => (
                  <th key={col} className={`text-left ${style.extendedRowSpace}`}>
                    <span>{col}</span>
                  </th>
                ))
              )}
              {[...Array(infractionName == "IT_ATTENTIVE_DRIVING" ? emptyHeadersCount + headerDiscount + 15 : emptyHeadersCount)].map((_, i) => (
                <th key={`empty-header-${i}`}></th>
              ))}
            </tr>
          </thead>
          <tbody>
            {row.items.map((item: any) => (
              <tr className='extendedRow' key={crypto.randomUUID()}>
                <td className='text-size-14' data-field='detailLastUpdate'>
                  {datetimeFormatter.format(new Date(item['detailLastUpdate' as keyof IInfractionResult]))}
                </td>
                <td className='text-size-14' data-field='coordinates'>
                  {item.lat != null && item.lng != null ? (
                    <button
                      className={`btn ${style.btnMap}`}
                      style={{ backgroundColor: 'transparent' }}
                      onClick={() => handleShowMap(item.lat, item.lng)}
                    >
                      <span className='rioglyph rioglyph-map-marker'></span>{' '}
                      {formatCoordinates(item.lat, item.lng)}
                    </button>
                  ) : (
                    MISSING_VALUE
                  )}
                </td>
                {infractionName == "IT_ATTENTIVE_DRIVING" && item.detailCauses ? (
                  <td colSpan={20} className='text-size-14'>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', width: '100%' }}>

                      {/* MAP 1: Percorre os objetos (os grupos de causas) */}
                      {item.detailCauses.map((group: any, groupIndex: number) => {

                        // Seleciona a cor baseada no índice do grupo (usa o resto da divisão para não estourar o array)
                        const colorStyle = GROUP_COLORS[groupIndex % GROUP_COLORS.length];

                        return (
                          <div key={`group-${groupIndex}`} style={{ 
                            display: 'flex', gap: '6px', border: `1px dashed ${colorStyle.border}`,
                             padding: '4px', borderRadius: '8px', justifyContent: 'flex-start', width: '40%', flex: '1 1 auto',
                          }}>

                            {/* MAP 2: Percorre os pares chave:valor dentro deste grupo específico */}
                            {Object.entries(group).map(([key, value], pairIndex) => {
                              const labelKey = ATTENTIVEDRIVINGKEYTRANSLATOR[key] || key;
                              const labelValue = ATTENTIVEDRIVINGVALUETRANSLATOR[value as string] || value as string;

                              return (
                                <div
                                  key={`${groupIndex}-${pairIndex}`}
                                  className="label"
                                  style={{
                                    backgroundColor: colorStyle.bg,
                                    color: colorStyle.color,
                                    border: `1px solid ${colorStyle.border}`,
                                    padding: '4px 10px',
                                    borderRadius: '4px',
                                    fontWeight: 'bold',
                                    whiteSpace: 'nowrap',
                                    flex: '1 1 auto',
                                  }}
                                >
                                  {labelKey}: {labelValue}
                                </div>
                              );
                            })}
                          </div>
                        );
                      })}
                    </div>
                  </td>
                ) : (
                  <td className='text-size-14'>
                    <span>{formatMeasuredValue(item['detailMeasuredValue'], infractionName)}</span>
                  </td>
                )}
                {[...Array(emptyCellsCount)].map((_, i) => (
                  <td key={`empty-cell-${i}`}></td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </td>
    </tr>
  );
};

export default ExpandedRowDetails;